import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

// Sits above normal page content but below the Modal (Modal uses z-index
// 1000/1001 - see @sunrun/experience-ui-components' Modal.tsx).
const FLOATING_INDICATOR_Z_INDEX = 900;

const FloatingContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: ${FLOATING_INDICATOR_Z_INDEX};
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

const RecordingDot = styled.span<{ dim?: boolean }>`
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #ff4d6d;
  opacity: ${({ dim }) => (dim ? 0.5 : 1)};
  animation: ${({ dim }) => (dim ? "none" : pulse)} 1.2s ease-in-out infinite;
`;

const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px 10px 18px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
`;

const PillLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.2px;
  white-space: nowrap;
`;

const TimerText = styled.span`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.3px;
  min-width: 44px;
`;

const StopButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px;
  border: none;
  border-radius: 999px;
  background: #ff4d6d;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #e63e5c;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export {
  FloatingContainer,
  Pill,
  PillLabel,
  RecordingDot,
  StopButton,
  TimerText,
};
